<template>
  <div class="client-sidebar-nav" v-if="isVisible">
    <div class="menu-item">
      <router-link to="/" custom v-slot="{ href, navigate, isActive, isExactActive }">
        <a :href="href" @click="navigate" class="menu-link" :class="{ 'active': isActive || isExactActive }">
          <span class="menu-icon">
            <i class="ki-duotone ki-element-11 text-primary fs-2">
              <span class="path1"></span>
              <span class="path2"></span>
              <span class="path3"></span>
              <span class="path4"></span>
            </i>
          </span>
          <span class="menu-title">Prima pagina</span>
        </a>
      </router-link>
    </div>

    <div class="menu-item pt-5">
      <div class="menu-content">
        <span class="menu-heading fw-bold text-uppercase fs-7">Vanzari</span>
      </div>
    </div>

    <div class="menu-item">
      <router-link to="/intrari/facturi" custom v-slot="{ href, navigate, isActive }">
        <a :href="href" @click="navigate" class="menu-link" :class="{ 'active': isActive }">
          <span class="menu-icon">
            <i class="ki-duotone ki-bill text-success fs-2">
              <span class="path1"></span>
              <span class="path2"></span>
              <span class="path3"></span>
              <span class="path4"></span>
              <span class="path5"></span>
              <span class="path6"></span>
            </i>
          </span>
          <span class="menu-title">Facturi Intrare</span>
        </a>
      </router-link>
    </div>

    <div class="menu-item">
      <router-link to="/facturare" custom v-slot="{ href, navigate, isActive }">
        <a :href="href" @click="navigate" class="menu-link" :class="{ 'active': isActive }">
          <span class="menu-icon">
            <i class="ki-duotone ki-bill text-success fs-2">
              <span class="path1"></span>
              <span class="path2"></span>
              <span class="path3"></span>
              <span class="path4"></span>
              <span class="path5"></span>
              <span class="path6"></span>
            </i>
          </span>
          <span class="menu-title">Facturi Iesire</span>
        </a>
      </router-link>
    </div>

    <div class="menu-item">
      <router-link to="/facturare/fp" custom v-slot="{ href, navigate, isActive }">
        <a :href="href" @click="navigate" class="menu-link" :class="{ 'active': isActive }">
          <span class="menu-icon">
            <i class="ki-duotone ki-bill text-success fs-2">
              <span class="path1"></span>
              <span class="path2"></span>
              <span class="path3"></span>
              <span class="path4"></span>
              <span class="path5"></span>
              <span class="path6"></span>
            </i>
          </span>
          <span class="menu-title">Factura Proforma</span>
        </a>
      </router-link>
    </div>

    <div class="menu-item">
      <router-link to="/incarcari" custom v-slot="{ href, navigate, isActive }">
        <a :href="href" @click="navigate" class="menu-link" :class="{ 'active': isActive }">
          <span class="menu-icon">
            <i class="ki-duotone ki-bill text-success fs-2">
              <span class="path1"></span>
              <span class="path2"></span>
              <span class="path3"></span>
              <span class="path4"></span>
              <span class="path5"></span>
              <span class="path6"></span>
            </i>
          </span>
          <span class="menu-title">Documente</span>
        </a>
      </router-link>
    </div>

    <div class="menu-item">
      <router-link to="/plan-conturi" custom v-slot="{ href, navigate, isActive }">
        <a :href="href" @click="navigate" class="menu-link" :class="{ 'active': isActive }">
          <span class="menu-icon">
            <i class="ki-duotone ki-bill text-success fs-2">
              <span class="path1"></span>
              <span class="path2"></span>
              <span class="path3"></span>
              <span class="path4"></span>
              <span class="path5"></span>
              <span class="path6"></span>
            </i>
          </span>
          <span class="menu-title">Plan Conturi</span>
        </a>
      </router-link>
    </div>

    <div class="menu-item">
      <router-link :to="$gate?.isPfa() ? '/registru-incasari-plati' : '/registru-jurnal'" custom v-slot="{ href, navigate, isActive }">
        <a :href="href" @click="navigate" class="menu-link" :class="{ 'active': isActive }">
          <span class="menu-icon">
            <i class="ki-duotone ki-bill text-success fs-2">
              <span class="path1"></span>
              <span class="path2"></span>
              <span class="path3"></span>
              <span class="path4"></span>
              <span class="path5"></span>
              <span class="path6"></span>
            </i>
          </span>
          <span class="menu-title">{{ $gate?.isPfa() ? 'Registru Încasări și Plăți' : 'Registru Jurnal' }}</span>
        </a>
      </router-link>
    </div>

    <div class="menu-item pt-5">
      <div class="menu-content">
        <span class="menu-heading fw-bold text-uppercase fs-7">Setari & Cont</span>
      </div>
    </div>

    <div class="menu-item">
      <router-link to="/firmele-mele" custom v-slot="{ href, navigate, isActive }">
        <a :href="href" @click="navigate" class="menu-link" :class="{ 'active': isActive }">
          <span class="menu-icon">
            <i class="ki-duotone ki-bill text-success fs-2">
              <span class="path1"></span>
              <span class="path2"></span>
              <span class="path3"></span>
              <span class="path4"></span>
              <span class="path5"></span>
              <span class="path6"></span>
            </i>
          </span>
          <span class="menu-title">Firmele Mele</span>
        </a>
      </router-link>
    </div>

    <div class="menu-item">
      <router-link to="/contul-meu" custom v-slot="{ href, navigate, isActive }">
        <a :href="href" @click="navigate" class="menu-link" :class="{ 'active': isActive }">
          <span class="menu-icon">
            <i class="ki-duotone ki-bill text-success fs-2">
              <span class="path1"></span>
              <span class="path2"></span>
              <span class="path3"></span>
              <span class="path4"></span>
              <span class="path5"></span>
              <span class="path6"></span>
            </i>
          </span>
          <span class="menu-title">Contul Meu</span>
        </a>
      </router-link>
    </div>

    <template v-if="$gate?.isAdmin()">
      <div class="menu-item pt-5">
        <div class="menu-content">
          <span class="menu-heading fw-bold text-uppercase fs-7">Administrare</span>
        </div>
      </div>
      <div class="menu-item">
        <router-link to="/administrare/utilizatori" custom v-slot="{ href, navigate, isActive }">
          <a :href="href" @click="navigate" class="menu-link" :class="{ 'active': isActive }">
            <span class="menu-icon">
              <i class="ki-duotone ki-bill text-danger fs-2">
                <span class="path1"></span>
                <span class="path2"></span>
                <span class="path3"></span>
                <span class="path4"></span>
                <span class="path5"></span>
                <span class="path6"></span>
              </i>
            </span>
            <span class="menu-title">Utilizatori</span>
          </a>
        </router-link>
      </div>
      <div class="menu-item">
        <router-link to="/administrare/firme" custom v-slot="{ href, navigate, isActive }">
          <a :href="href" @click="navigate" class="menu-link" :class="{ 'active': isActive }">
            <span class="menu-icon">
              <i class="ki-duotone ki-bill text-danger fs-2">
                <span class="path1"></span>
                <span class="path2"></span>
                <span class="path3"></span>
                <span class="path4"></span>
                <span class="path5"></span>
                <span class="path6"></span>
              </i>
            </span>
            <span class="menu-title">Firme</span>
          </a>
        </router-link>
      </div>
      <div class="menu-item">
        <router-link to="/administrare/abonamente" custom v-slot="{ href, navigate, isActive }">
          <a :href="href" @click="navigate" class="menu-link" :class="{ 'active': isActive }">
            <span class="menu-icon">
              <i class="ki-duotone ki-bill text-danger fs-2">
                <span class="path1"></span>
                <span class="path2"></span>
                <span class="path3"></span>
                <span class="path4"></span>
                <span class="path5"></span>
                <span class="path6"></span>
              </i>
            </span>
            <span class="menu-title">Abonamente</span>
          </a>
        </router-link>
      </div>
    </template>
  </div>
</template>

<script>
import { useUserStore } from '../../../stores/user';

export default {
  name: 'ClientSidebarMenu',
  setup() {
    const userStore = useUserStore();
    return { userStore };
  },
  computed: {
    isVisible() {
      const canWork = (this.$gate && typeof this.$gate.canWorkOnFirms === 'function')
        ? this.$gate.canWorkOnFirms()
        : (this.$gate?.isAdmin() || false);

      if (!canWork) return true;

      const mode = this.userStore.currentSidebarMode || 'tot';
      return mode === 'client' || mode === 'tot';
    }
  }
};
</script>
